import { useEffect } from "react";

const Privacidad = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <div className="privacidad">
      <h1>DECLARACIÓN DE PRIVACIDAD</h1>

      <span>----</span>

      <h2>SECCIÓN 1 - ¿QUÉ HACEMOS CON TU INFORMACIÓN?</h2>

      <p>
        Cuando compras algo de nuestra tienda, como parte del proceso de compra
        venta, nosotros recolectamos la información personal que nos parece
        necesaria tales como nombre, dirección y correo electrónico.
      </p>
      <p>
        Cuando navegas en nuestro sitio, también recibimos de manera automática
        la dirección de protocolo de internet de tu computadora (IP) con el fin
        de proporcionarnos información que nos ayuda a conocer acerca de su
        navegador y sistema operativo.
      </p>
      <p>
        Email marketing: Con tu permiso, podremos enviarte correos electrónicos
        acerca de nuestra tienda, nuevos productos y otras actualizaciones
      </p>

      <h2>SECCIÓN 2 - CONSENTIMIENTO</h2>

      <p>¿Cómo obtienen mi consentimiento?</p>

      <p>
        Cuando nos provees tu información personal para enviar una oferta,
        enviar mensaje o contactar un representante comercial implicamos que
        aceptas la recolección y uso por esa razón específica solamente.
      </p>

      <p>
        Si te pedimos tu información personal por una razón secundaria, como
        marketing, te pediremos directamente tu expreso consentimiento, o te
        daremos la oportunidad de negarte.
      </p>

      <p>¿Cómo puedo anular mi consentimiento?</p>

      <p>
        Si luego de haber aceptado cambias de opinión, puedes anular tu
        consentimiento para que te contactemos, por la recolección, uso o
        divulgación de tu información, en cualquier momento, contactandonos a
        privacidad@campomercado.com o escribiéndonos a: RITERY SA Av. Dr. Luis
        Alberto de Herrera 1248, Montevideo, MO, 11200, Uruguay
      </p>

      <h2>SECCIÓN 3 - DIVULGACIÓN</h2>

      <p>
        Podemos divulgar tu información personal si se nos requiere por ley o si
        violas nuestros Términos de Servicio.
      </p>

      <h2>SECCIÓN 4 - SEGURIDAD</h2>

      <p>
        Para proteger tu información personal, tomamos precauciones razonables y
        seguimos las mejores prácticas de la industria para asegurarnos de que
        no haya pérdida de manera inapropiada, mal uso, acceso, divulgación,
        alteración o destrucción de la misma.
      </p>

      <p>
        Aunque ningún método de transmisión a través de Internet o de
        almacenamiento electrónico es 100% seguro, seguimos todos los requisitos
        de PCI-DSS e implementamos normas adicionales aceptadas por la
        industria.
      </p>

      <h2>SECCIÓN 5 - EDAD DE CONSENTIMIENTO</h2>

      <p>
        Al utilizar este sitio, declaras que tienes al menos la mayoría de edad
        en tu estado o provincia de residencia, o que tienes la mayoría de edad
        en tu estado o provincia de residencia y que nos has dado tu
        consentimiento para permitir que cualquiera de tus dependientes menores
        use este sitio.
      </p>

      <h2>SECCIÓN 6 - CAMBIOS A ESTA POLÍTICA DE PRIVACIDAD</h2>

      <p>
        Nos reservamos el derecho de modificar esta política de privacidad en
        cualquier momento, así que por favor revísala frecuentemente. Cambios y
        aclaraciones entrarán en vigencia inmediatamente después de su
        publicación en el sitio web. Si hacemos cambios materiales a esta
        política, notificaremos aquí que ha sido actualizada, por lo que cual
        estás enterado de qué información recopilamos, cómo y bajo qué
        circunstancias, si las hubiere, la utilizamos y/o divulgamos.
      </p>

      <p>
        Si nuestra empresa es adquirida o fusionada con otra empresa, tu
        información puede ser transferida a los nuevos propietarios, para que
        podamos seguir vendiéndote productos.
      </p>

      <h2>PREGUNTAS E INFORMACIÓN DE CONTACTO</h2>

      <p>
        Si quieres: acceder, corregir, enmendar o borrar cualquier información
        personal que poseamos sobre ti, registrar una queja, o simplemente
        quieres más información contacta a nuestro Oficial de Cumplimiento de
        Privacidad privacidad@campomercado.com o por correo postal a RITERY SA
      </p>

      <p>[Re: RITERY SA]</p>

      <p>
        [Av. Dr. Luis Alberto de Herrera 1248, Montevideo, MO, 11200, Uruguay]
      </p>

      <span>----</span>
    </div>
  );
};

export default Privacidad;
